import React from 'react'
import {
    HashRouter as Router,
    Switch,
    Route
} from 'react-router-dom'
import Enquiry from '../container/enquiry';

export default function EnquiryRouter(props) {

    return (
        <Router>
            <Switch>
                <Route path="/*" exact={true} component={Enquiry} />

                <Route>Not Found!</Route>
            </Switch>
        </Router>

    )
}
